import { ENTERPRISE_CALLBACK_VERBS } from './callbackConstants';

export const headersToRows = headers => {
  if (Array.isArray(headers)) {
    return headers.map(h => ({
      key: h.key ?? h.name ?? '',
      value: h.value != null ? String(h.value) : ''
    }));
  }
  if (headers && typeof headers === 'object') {
    return Object.entries(headers).map(([key, value]) => ({
      key,
      value: value != null ? String(value) : ''
    }));
  }
  return [];
};

export const rowsToObject = rows => {
  const o = {};
  rows.forEach(({ key, value }) => {
    const k = key?.trim();
    if (k) o[k] = value ?? '';
  });
  return o;
};

export const isValidVerbValue = value => ENTERPRISE_CALLBACK_VERBS.some(v => v.value === value);

export const mapFromApi = (row, index) => {
  let verbValue = 1; // Default to POST (value 1)
  if (row.callback_url_verb != null && row.callback_url_verb !== '') {
    verbValue = Number(row.callback_url_verb);
  }
  const events = Array.isArray(row.callback_events)
    ? row.callback_events.map(e => String(e).toLowerCase())
    : Array.isArray(row.events)
      ? row.events.map(e => String(e).toLowerCase())
      : [];

  return {
    localId: String(row.id ?? `row-${index}`),
    id: row.id ?? null,
    name: row.name ?? `Callback ${index + 1}`,
    callbackTargetType: row.callback_target_type ?? 1,
    verb: isValidVerbValue(verbValue) ? verbValue : 1,
    url: row.callback_url ?? row.url ?? '',
    events,
    callbackRequireData: row.callback_require_data ?? false,
    headers: headersToRows(row.extra_headers ?? row.headers)
  };
};

export const buildApiPayload = c => ({
  name: c.name,
  callback_target_type: c.callbackTargetType ?? 1,
  callback_url: c.url,
  callback_url_verb: c.verb,
  callback_events: c.events,
  callback_require_data: c.callbackRequireData ?? false,
  extra_headers: rowsToObject(c.headers)
});
